import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

const WebviewManager = ({ accounts, activeId }) => {
  const [loadingStates, setLoadingStates] = useState(
    accounts.reduce((acc, account) => ({ ...acc, [account.id]: true }), {})
  );

  const handleLoad = (id) => {
    setLoadingStates(prev => ({ ...prev, [id]: false }));
  };

  return (
    <div className="flex-1 relative bg-gray-900 h-full overflow-hidden">
      {/* 
        DEVELOPER NOTE:
        In a native wrapper (Capacitor/Electron), these iframes should be replaced 
        with native Webview instances configured to use isolated session/cookie stores.
        Standard iframes in a browser will share session data for the same domain.
      */}
      {accounts.map((account) => {
        const isActive = account.id === activeId;
        const isLoading = loadingStates[account.id];

        return (
          <div 
            key={account.id} 
            className={`absolute inset-0 w-full h-full transition-opacity duration-300 ${isActive ? 'opacity-100 z-10' : 'opacity-0 z-0 pointer-events-none'}`}
          >
            {isActive && isLoading && (
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-900 text-gray-400 z-20">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
                <p>Establishing secure connection to {account.name}...</p>
              </div>
            )}
            
            <div className="w-full h-full bg-gray-950 flex flex-col items-center justify-center text-gray-500 p-8 text-center">
               <SafeIcon icon="FiMonitor" className="text-6xl mb-4 opacity-20" />
               <h3 className="text-xl font-semibold text-gray-300 mb-2">Webview Container: {account.name}</h3>
               <p className="max-w-md text-sm mb-6">
                 In production, the iframe below will render <code>https://web.max.ru</code>. <br/><br/>
                 Due to X-Frame-Options/CORS security policies on external sites, embedding via standard browser iframe is often blocked. This visualizer demonstrates the multi-instance architecture.
               </p>
               
               {/* 
                 The actual iframe implementation. 
                 We allow all necessary permissions required for a communication app.
               */}
               <iframe
                src={`https://example.com?account=${account.id}`} // Mocking the URL for preview safety
                title={`Webview ${account.name}`}
                className="w-full h-full bg-white rounded-xl border border-gray-700 shadow-2xl overflow-hidden"
                onLoad={() => handleLoad(account.id)}
                allow="camera; microphone; display-capture; fullscreen; geolocation; autoplay"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WebviewManager;